import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import moment from 'moment';
import { createAsyncAction } from '@smorder/logic';
import SmorderActions from '../models/smorderActions';

const minutesToMidnight = moment.duration(moment().endOf('day').diff(moment())).asMinutes();


const INITIAL_STATE = Immutable({
  orders: [],
  orderhistory: [],
  // durationInMinutes: moment.duration(1, 'day').asMinutes(),
  selectedMode: 'day',
  ordersStartDate: moment().startOf('day').toDate(),
  ordersEndDate: moment().endOf('day').toDate(),
  lastUpdate: new Date(),
  loading: false,
  orderSearchValue: null,
  selectedOrder: null,
  selectedOrders: [],
  selectedOrderForDeliveryInfo: null,
  selectedOrderForDeliveryTimeInfo: null,
  printerInitialized: false,
  reconnectingPrinter: false,
  printingorders: {},
  exportingOrders: {},
  printingProductLabels: {},
  ordersProductionPlace: null,
  selectableDurations: [
    { value: 'Ueberfaellig', text: 'Überfällig', id: 'Ueberfaellig', slide: true, orders: 0 },
    { value: 'Route', text: 'Route', id: 'Route', slide: true, orders: 0 },
    { value: 'Verlauf', text: 'Verlauf', id: 'Verlauf', slide: true, orders: 0 },
    { value: 30, text: '30 min', id: '30', slide: true, orders: 0 },
    { value: 60, text: '60 min', id: '60', slide: true, orders: 0 },
    { value: 180, text: '3 Std', id: '180', slide: true, orders: 0 },
    { value: minutesToMidnight, text: 'heute', id: 'day', orders: 0 },
    { value: minutesToMidnight, text: 'Morgen', id: 'Morgen', slide: true, orders: 0 },
    { value: minutesToMidnight, text: 'Übermorgen', id: 'Uebermorgen', slide: true, orders: 0 },
  ],
  routeplanning: false,
  routestops: [],
  openRouteDialog: false,
  openArticlelistDialog: false,
  openReportDialog: false,
});

export const loadOrders = createAction('LOADORDERS');
export const loadOrdersSucceeded = createAction('LOADORDERSSUCCEEDED');
export const loadOrdersFailed = createAction('LOADORDERSFAILED');

export const loadOrder = createAction('LOADORDER');
export const loadOrderSucceeded = createAction('LOADORDERSUCCEEDED');
export const loadOrderFailed = createAction('LOADORDERFAILED');

export const loadReports = createAction('LOADREPORTS');
export const loadReportsSucceeded = createAction('LOADREPORTSSUCCEEDED');
export const loadReportsFailed = createAction('LOADREPORTSFAILED');

export const orderUpdatedOnServer = createAction('ORDERUPDATEDONSERVER');
export const setMode = createAction('SETMODE');

export const proceedOrder = createAction('PROCEEDORDER');
export const proceedAllVisibleOrders = createAction('PROCEEDALLVISIBLEORDERS');
export const proceedAllVisibleOrdersDone = createAction('PROCEEDALLVISIBLEORDERSDONE');
export const declineOrder = createAction('DECLINEORDER');
export const selectOrder = createAction('SELECTORDER');
export const removeOrderFromSelection = createAction('REMOVE_SELECTORDER');

export const selectOrderForDeliveryInfo = createAction('SELECTORDER_DELIVERY');
export const addOrderToHistory = createAction('ADDORDERTOHISTORY');
export const resetOrderHistory = createAction('RESETORDERHISTORY');
export const actionOnOrdercard = createAction('ACTIONONORDERCARD');

export const removeObsoleteOrders = createAction('REMOVEOBSOLETEORDERS');
export const updateOrderView = createAction('UPDATEORDERVIEW');

export const setOrderSearchValue = createAction('SETORDERSEARCHVALUE');
export const resetOrderSearchValue = createAction('RESETORDERSEARCHVALUE');

export const startPrintOrder = createAction('STARTPRINTORDER');
export const finishPrintOrder = createAction('FINISHPRINTORDER');
export const printOrderFailed = createAction('PRINTORDERFAILED');

export const startExportOrder = createAction('START_EXPORT_ORDER');
export const finishExportOrder = createAction('FINISH_EXPORT_ORDER');
export const exportOrderFailed = createAction('EXPORT_ORDER_FAILED');

export const startCheckExportPossible = createAction('START_EXPORT_POSSIBLE');
export const finishCheckExportPossible = createAction('FINISH_EXPORT_POSSIBLE');
export const checkExportPossibleFailed = createAction('EXPORT_POSSIBLE_FAILED');

export const printAllLabels = createAction('STARTPRINTALLLABELS');

export const startPrintProductLabels = createAction('STARTPRINTPRODUCTLABELS');
export const finishPrintProductLabels = createAction('FINISHPRINTPRODUCTLABELS');
export const printProductLabelsFinished = createAction('DONEPRINTPRODUCTLABELS');

export const startPrintControlList = createAction('STARTPRINTCONTROLLIST');
export const finishPrintControlList = createAction('FINISHPRINTCONTROLLIST');
export const printControlListFailed = createAction('PRINTCONTROLLISTFAILED');

export const initPrinter = createAction('INITPRINTER');
export const initPrinterFailed = createAction('INITPRINTERFAILED');
export const reconnectPrinter = createAction('RECONNECTPRINTER');
export const reconnectPrinterFinished = createAction('RECONNECTPRINTERFINISHED');
export const printArticleList = createAction('PRINTARTICLELSIST');

export const startNewRoutePlanning = createAction('STARTNEWROUTEPLANNING');
export const editRoutePlanning = createAction('EDITROUTEPLANNING');
export const finishRoutePlanning = createAction('FINISHROUTEPLANNING');
export const addOrderToRoute = createAction('ADDORDERTOROUTE');
export const removeOrderFromRoute = createAction('REMOVEORDERFROMROUTE');
export const openRouteDialog = createAction('OPENROUTEDIALOG');
export const closeRouteDialog = createAction('CLOSEROUTEDIALOG');
export const openArticlelistDialog = createAction('OPENARTICLELISTDIALOG');
export const closeArticlelistDialog = createAction('CLOSEARTICLELISTDIALOG');

export const openReportDialog = createAction('OPENREPORTDIALOG');
export const closeReportDialog = createAction('CLOSEREPORTDIALOG');

export const setNewOrderAlertVisible = createAction('NEWORDERALERT');
export const addNewOrderToQueue = createAction('NEWORDERALERTQUEUE');

export const setDeliveryTimeAction = createAsyncAction('setDeliveryTime');
export const selectOrderForDeliveryTimeInfo = createAction('selectOrderForDeliveryTimeInfo');

export const setProductionPlaceOrderFilter = createAction('setProductionPlaceOrderFilter');
export const setOrderSpotFilter = createAction('setOrderSpotFilter');
export const downloadLabels = createAction('downloadLabels');

export const mapOrder = o => ({
  id: o.orderId,
  pickupName: o.pickupName,
  pickupCode: o.pickupNumber,
  parentOrderId: o.parentOrderId,
  pickupTime: o.preOrderTime ? moment.utc(o.preOrderTime).local().format('HH:mm') : o.preOrderTime,
  pickupDate: o.preOrderTime ? moment.utc(o.preOrderTime).local().format('DD.MM.YYYY') : o.preOrderTime,
  pickupTimeIsSet: o.preOrderTime ? moment(o.preOrderTime).hours() > 3 : false,
  isPreOrder: !!o.preOrderTime,
  slotName: o.slotName,
  spotLayoutName: o.spotLayoutName,
  eventName: o.eventName,
  pickupTimeNumeric: o.preOrderTime ? moment.utc(o.preOrderTime).valueOf() : moment.utc(o.dateTime).valueOf(),
  orderTime: o.dateTime ? moment.utc(o.dateTime).local().format('HH:mm') : o.dateTime,
  orderDate: o.dateTime ? moment.utc(o.dateTime).local().format('DD.MM.YYYY') : o.dateTime,
  proceedText: o.proceedTextInWaiterUi,
  productionPlaceId: o.productionPlaceId,
  color: o.proceedColorInWaiterUi,
  show: o.show,
  note: o.note,
  userNote: o.userNote,
  canReject: o.canReject,
  canPrint: true,
  canUndo: o.actionsAllowed && o.actionsAllowed.includes(SmorderActions.Undo),
  loading: false,
  guid: o.guid,
  parentOrderGuid: o.parentOrderGuid,
  address: o.address,
  telephone: o.telephone,
  userPublicIdentifier: o.userPublicIdentifier,
  totalPrice: o.totalPrice,
  spotName: o.spotName,
  additionalSpotInfo: o.additionalSpotInfo, 
  isDelivery: !!o.address,
  takeaway: o.takeaway,
  tip: o.tip,
  stateName: o.stateName,
  articles: o.entries.map(e => ({
    id: e.id,
    labelPrintCount: e.labelPrintCount,
    name: e.productName,
    quantity: e.amount,
    note: e.note,
    stateName: o.stateName,
    price: e.price + e.features.reduce((sum, feature) => sum + feature.price, 0),
    features: [
      ...e.features.filter(x => x.value && !x.isDeselectFeature).map(f => (f.amount > 1 ? `${f.amount}x ${f.value}` : f.value)),
      ...e.productVariants.map(p => p.values.map(v => v.variantValue)).reduce((a, b) => a.concat(b), []),
      ...e.features.filter(x => x.value && x.isDeselectFeature && x.deselectedByUser).map(f => `Abwahl: ${f.value}`),
    ],
    featuresUnmapped: [
      ...e.features,
    ],
  })),
  newOrderAlertOpen: false,
  newOrderQueue: [],
  actionsAllowed: o.actionsAllowed,
});

const setOrderToLoadingState = (state, orderId) => {
  const indexOfOrder = state.orders.findIndex(o => o.id === orderId);
  const indexOfNewOrderQueue = (state.newOrderQueue || []).findIndex(o => o.id === orderId);

  let newState = state;

  if (indexOfOrder !== -1) {
    newState = newState.setIn(['orders', indexOfOrder, 'loading'], true);
  }

  if (indexOfNewOrderQueue !== -1) {
    newState = newState.setIn(['newOrderQueue', indexOfNewOrderQueue, 'loading'], true);
  }

  return newState;
};

const setOrderPrintingState = (state, orderId, newState) => {
  if (newState) {
    return state.merge({ printingorders: state.printingorders.set(orderId, newState) });
  }
  return state.merge({ printingorders: state.printingorders.without(orderId) });
};


const setOrderExportingState = (state, orderId, newState) => {
  if (newState) {
    return state.merge({ exportingOrders: state.exportingOrders.set(orderId, newState) });
  }
  return state.merge({ exportingOrders: state.exportingOrders.without(orderId) });
};

const setProductLabelPrintingState = (state, printingInfo, newState) => {
  
  let printingProductLabels = state.printingProductLabels;

  printingInfo.forEach(info => {
    if (newState) {
      printingProductLabels = printingProductLabels.set(info.id, newState);
    } else {
      printingProductLabels = printingProductLabels.without(info.id);
    }     
  });

  return state.merge({ printingProductLabels });
};


const setFilterMode = (state, modeid, startdate, enddate) => {
  const mode = state.selectableDurations.filter(mode => mode.id === modeid)[0];


  const ordersStartDate = startdate || moment().add(-30, 'minute').toDate();
  const ordersEndDate = enddate || moment().add(mode.value, 'minute').toDate();

  return state.merge({
    selectedMode: modeid,
    ordersStartDate,
    ordersEndDate,
    relativeDurationMilliseconds: mode ? moment.duration(moment(moment().add(mode.value, 'minute').toDate()).diff(moment())).asMilliseconds() : 0,
    slidingWindowModeEnabled: mode ? mode.slide : true,
  });
};

const toggleOrderInRoute = (state, order, shouldBeInRoute) => {
  const routestops = state.routestops.asMutable();

  if (shouldBeInRoute) {
    if (!routestops.includes(order.id)) {
      routestops.push(order.id);
    }
  } else if (routestops.includes(order.id)) {
    routestops.splice(routestops.indexOf(order.id), 1);
  }

  let selectedMode = state.selectedMode;

  if (selectedMode === 'Route' && routestops.length === 0) {
    selectedMode = 'day';
  }

  return state.merge({ routestops, selectedMode });
};

const reducers = createReducer({
  // [actionOnOrdercard]: (state, { order, action }) => {
  //   debugger
  //   if (action === SmorderActions.Undo) {
  //     const newOrder = {
  //       ...order,
  //       show: true,
  //       loading: false,
  //       dispatchEvent: null,
  //     }
      
  //     const orderHistoryWithoutOrder = state.orderhistory.filter(o => o.id !== order.id);

  //     return state.merge({ orders: [newOrder, ...state.orders], orderhistory: orderHistoryWithoutOrder });
  //   }

  //   return state;
  // },
  [loadOrders]: state => state.merge({ loading: true }),
  [loadOrder]: (state, orderId) => setOrderToLoadingState(state, orderId),
  [proceedOrder]: (state, orderId) => setOrderToLoadingState(state, orderId),
  [declineOrder]: (state, orderId) => setOrderToLoadingState(state, orderId),
  [loadOrdersSucceeded]: (state, { orders }) => {
    const newOrders = orders.map(mapOrder);
    return state.merge({ orders: newOrders, loading: false });
  },
  [loadReportsSucceeded]: (state, { reports }) => {
    return state.merge({ reports });
  },
  [loadOrderFailed]: (state, orderId) => {
    const indexOfOrder = state.orders.findIndex(o => o.id === orderId);
    return state.setIn(['orders', indexOfOrder, 'loading'], false);
  },
  [loadOrderSucceeded]: (state, { order }) => {
    const indexOfOrder = state.orders.findIndex(o => o.id === order.orderId);
    const newOrder = mapOrder(order);

    if (order.show == false && order.actionsAllowed && order.actionsAllowed.includes(SmorderActions.Undo)) {
            
      const indexOfOrderInHistory = state.orderhistory.findIndex(o => o.id === order.orderId);

      let newState = state;

      if (indexOfOrder !== -1 && !newOrder.show) {
        newState =  newState.setIn(['orders', indexOfOrder, 'show'], false);
      }
      
      if (indexOfOrderInHistory !== -1) {
        return newState.setIn(['orderhistory', indexOfOrderInHistory], { ...state.orderhistory[indexOfOrderInHistory], ...newOrder, show: true });
      }      
    }


    if (indexOfOrder === -1 && newOrder.show) {
      const orders = state.orders.asMutable();
      let i;
      for (i = 0; i < orders.length; i++) {
        if (orders[i].pickupTimeNumeric > newOrder.pickupTimeNumeric || (orders[i].pickupTime && !orders[i].pickupTimeIsSet)) {
          break;
        }
      }

      orders.splice(i, 0, newOrder);
      return state.merge({ orders });
    } else if (indexOfOrder !== -1 && !newOrder.show) {
      return state.setIn(['orders', indexOfOrder, 'show'], false);
    }

    return state.setIn(['orders', indexOfOrder], newOrder);
  },
  [addOrderToHistory]: (state, { order, description, blockUser, note, proceeded, action }) => {

    if (action === SmorderActions.Undo) {
      const newOrder = {
        ...order,
        show: true,
        loading: false,
        dispatchEvent: null,
      }
      
      const orderHistoryWithoutOrder = state.orderhistory.filter(o => o.id !== order.id);

      return state.merge({ orders: [newOrder, ...state.orders], orderhistory: orderHistoryWithoutOrder });
    }

    const orderhistory = state.orderhistory.asMutable();
    const mutableOrder = { ...order };
    mutableOrder.show = true;
    mutableOrder.loading = false;

    mutableOrder.dispatchEvent = {
      timestamp: new Date(),
      description,
      note,
      blockUser,
      proceeded,
    };

    if (!orderhistory.flatMap(order => order.id).includes(mutableOrder.id)) {
      orderhistory.push(mutableOrder);
    }

    while (orderhistory.length > 300) {
      orderhistory.shift();
    }

    return state.merge({
      orderhistory,
    });
  },
  [resetOrderHistory]: state => state.merge({ orderhistory: [] }),
  [removeObsoleteOrders]: (state) => {
    const orders = state.orders.asMutable();
    const obsoleteOrders = orders.filter(o => !o.show);
    for (let i = 0; i < obsoleteOrders.length; i++) {
      const indexOfOrder = orders.findIndex(o => o.id === obsoleteOrders[i].id);
      orders.splice(indexOfOrder, 1);
    }

    return state.merge({
      orders,
    });
  },
  [loadOrdersFailed]: state => state.merge({ loading: false }),
  [setProductionPlaceOrderFilter]: (state, ordersProductionPlace) => state.merge({ ordersProductionPlace }),
  [setOrderSpotFilter]: (state, orderSpot) => state.merge({ orderSpot }),
  [setMode]: (state, { modeid, startdate, enddate }) => setFilterMode(state, modeid, startdate, enddate),
  [updateOrderView]: state => state.merge({
    lastUpdate: new Date(),
    ordersEndDate: state.slidingWindowModeEnabled && state.relativeDurationMilliseconds
      ? moment.min(moment().add(state.relativeDurationMilliseconds, 'milliseconds'), moment().endOf('day')).toDate()
      : state.ordersEndDate,
  }),
  [setOrderSearchValue]: (state, orderSearchValue) => state.merge({ orderSearchValue }),
  [selectOrder]: (state, selectedOrder) => state.merge({ 
    selectedOrder,
    selectedOrders: selectedOrder 
      ? [...(state.selectedOrders || []).filter((order) => order.id !== selectedOrder.id), selectedOrder] 
      : [], 
  }),
  [removeOrderFromSelection]: (state, selectedOrder) => {
    const selectedOrders = state.selectedOrders.filter((order) => order.id !== selectedOrder.id);
    return state.merge({ 
      selectedOrders,
      selectedOrder: selectedOrders.length ? selectedOrders[0] : null,
    });
  },
  [selectOrderForDeliveryInfo]: (state, selectedOrderForDeliveryInfo) => state.merge({ selectedOrderForDeliveryInfo }),
  [selectOrderForDeliveryTimeInfo]: (state, selectedOrderForDeliveryTimeInfo) => state.merge({ selectedOrderForDeliveryTimeInfo }),
  [startPrintOrder]: (state, order) => setOrderPrintingState(state, order.id, true),  
  [finishPrintOrder]: (state, order) => setOrderPrintingState(state, order.id, false),
  [startCheckExportPossible]: (state, order) => setOrderExportingState(state, order.id, true),  
  [finishCheckExportPossible]: (state, order) => setOrderExportingState(state, order.id, false),
  [startPrintProductLabels]: (state, {printLabelInfos}) => setProductLabelPrintingState(state, printLabelInfos, true),  
  [finishPrintProductLabels]: (state, {printLabelInfos}) => setProductLabelPrintingState(state, printLabelInfos, false),
  [initPrinter]: state => state.merge({ printerInitialized: true }),
  [initPrinterFailed]: state => state.merge({ printerInitialized: false }),
  [reconnectPrinter]: state => state.merge({ reconnectingPrinter: true }),
  [reconnectPrinterFinished]: state => state.merge({ reconnectingPrinter: false }),
  // [printArticleList]: (state) => state.merge({printinArticleList: true}),
  [startNewRoutePlanning]: state => state.merge({ routeplanning: true, routestops: [] }),
  [editRoutePlanning]: state => state.merge({ routeplanning: true }),
  [finishRoutePlanning]: state => state.merge({ routeplanning: false }),
  [addOrderToRoute]: (state, order) => toggleOrderInRoute(state, order, true),
  [removeOrderFromRoute]: (state, order) => toggleOrderInRoute(state, order, false),
  [openRouteDialog]: state => state.merge({ openRouteDialog: true }),
  [closeRouteDialog]: state => state.merge({ openRouteDialog: false }),
  [openReportDialog]: state => state.merge({ openReportDialog: true }),
  [closeReportDialog]: state => state.merge({ openReportDialog: false }),
  [openArticlelistDialog]: state => state.merge({ openArticlelistDialog: true }),
  [closeArticlelistDialog]: state => state.merge({ openArticlelistDialog: false }),
  [setNewOrderAlertVisible]: (state, newOrderAlertOpen) => state.merge({
    newOrderAlertOpen,
    newOrderQueue: newOrderAlertOpen ? state.newOrderQueue : [],
  }),
  [addNewOrderToQueue]: (state, order) => {
    const newOrderQueue = [...(state.newOrderQueue || []).filter(o => o.id != order.id), order].filter(o => o.show);
    return state.merge({
      newOrderQueue,
      newOrderAlertOpen: newOrderQueue.length > 0,
    });
  },
  [proceedAllVisibleOrders]: (state) => {
    return state.merge({ proceedingOrders: true });
  },
  [proceedAllVisibleOrdersDone]: (state) => {
    return state.merge({ proceedingOrders: false });
  }
}, INITIAL_STATE);

export default reducers;
